import { Navigate } from "react-router-dom";
import * as RouteInfo from './../RouteConstents';

export const CheckLogged = ({ children }) => {
  
  const userInfo = JSON.parse(localStorage.getItem('userInfo'));
  if (userInfo) {
    // user is not authenticated
    return <Navigate to={RouteInfo.ROUTE_DASHBOARD} />;
  }
  return children;
};